/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class UsePoint extends Component {
  state = {};
  _isMounted = false;

  componentDidMount = () => {
    this._isMounted = true;
    this._getData();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _getData = async () => {
    const { loginId } = this.props;
    const { _selectedDown, _allDownCheck, payGubun } = this.props.childProps;

    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._getDataApi();
      if (result) {
        const intReturn = result.data[0].intReturn;
        const userPoint = result.data[0].userPoint;
        const payPoint = result.data[0].payPoint;
        const exception = result.data[0].exception;
        const pointData = result.data[0].listData;
        //console.log(intReturn)
        //console.log(userPoint)
        //console.log(payPoint)
        //console.log(pointData)
        if (intReturn === 0) {
          if (this._isMounted) {
            this.setState({
              intReturn,
              pointData,
              userPoint,
              payPoint,
              exception,
            });
          }
        } else if (intReturn === -2) {
          toast.warn('19세 미만은 관람이 불가합니다.');
          this._onClose();
        } else if (intReturn === -3) {
          toast.warn(
            '보유하신 포인트가 부족하거나 존재하지 않습니다. 멤버십 또는 포인트 충전후 이용해 주세요'
          );
          this._onClose();
        } else if (intReturn === -1) {
          toast.warn('결제할 작품이 존재하지 않습니다.');
          this._onClose();
          if (payGubun === 'down') {
            _selectedDown();
            // _allDownCheck();
          }
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  _getDataApi = () => {
    const { contentSerial, subPartSerial2, payGubun, chksale } =
      this.props.childProps;
    const { apiUrl, loginId, authId, history } = this.props;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');
    //console.log(apiUrl + '/getPoint?userid=' + loginId + '&CheckedItems=' + subPartSerial2 + ',' + '&contentSerial=' + contentSerial + '&gubun=' + payGubun + '&chksale=' + chksale)
    //return axios(apiUrl + '/getPoint?userid=' + loginId + '&CheckedItems=' + subPartSerial2 + ',' + '&contentSerial=' + contentSerial + '&gubun=' + payGubun + '&chksale=' + chksale )
    return axios
      .post(
        apiUrl + '/getPoint',
        {
          params: {
            userid: loginId,
            authId: authId,
            CheckedItems: subPartSerial2,
            contentSerial: contentSerial,
            gubun:
              payGubun === '' || payGubun === null || payGubun === undefined
                ? 'vod'
                : payGubun,
            chksale: chksale,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken();
        } else if (error.response.status === 400) {
          history.push('/login');
        }
        //alert('오류가 발생했습니다.')
      });
  };
  _refreshToken = async () => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      this._getData();
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _onUsePoint = () => {
    const { onPointUse } = this.props.childProps;
    onPointUse();
  };
  _onClose = () => {
    const { onClose } = this.props.childProps;
    onClose();
  };
  _CommaFormatted = (str) => {
    ////console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  render() {
    const { pointData, userPoint, payPoint, exception, intReturn } = this.state;
    const { payGubun } = this.props.childProps;
    const { imgUrl } = this.props;

    return (
      <Fragment>
        {exception === 'N' ? (
          pointData ? (
            <Fragment>
              <h2>포인트 사용</h2>
              {intReturn === 0 ? (
                <Fragment>
                  <div className="cashcard_close">
                    <a
                      style={{ cursor: 'pointer', marginTop: 80 }}
                      onClick={this._onClose}
                    >
                      닫기
                    </a>
                  </div>
                  <div className="cashcard_pop_layer8">
                    <div className="cashcard_pop_top2">
                      <div className="div_dl">
                        <dl>
                          <dt>
                            <img src={pointData[0].img} />
                          </dt>
                          <dd>
                            <p>{pointData[0].title}</p>
                            <div>
                              {pointData[0].subTitle}{' '}
                              {pointData.length > 1
                                ? ' 외 ' + (pointData.length - 1) + '건'
                                : null}{' '}
                            </div>
                            <div>
                              {payGubun} {this._CommaFormatted(payPoint)}포인트
                            </div>
                          </dd>
                        </dl>
                      </div>
                    </div>
                    <div className="cashcard_pop_content">
                      <h2 className="cashcard_pop_h2_style1">결제내용</h2>
                      <table
                        width="100%"
                        border="0"
                        cellSpacing="0"
                        cellPadding="0"
                        className="cashcard_pop_table2"
                      >
                        <tbody>
                          <tr>
                            <th>보유포인트</th>
                            <td className="cashcard_pop_table2_text3">
                              {this._CommaFormatted(userPoint)}{' '}
                              <span>포인트</span>
                            </td>
                          </tr>
                          <tr>
                            <th>포인트사용</th>
                            <td className="cashcard_pop_table2_text4">
                              -{this._CommaFormatted(payPoint)}{' '}
                              <span>포인트사용</span>
                            </td>
                          </tr>

                          <tr>
                            <th>결제 후 잔액</th>
                            <td>
                              {this._CommaFormatted(userPoint - payPoint)}{' '}
                              포인트
                              {/*<span>포인트적립(5%)</span>*/}
                            </td>
                          </tr>

                          <tr>
                            <td
                              colSpan="2"
                              className="cashcard_pop_table2_text"
                            >
                              총결제 금액 :{' '}
                              <strong>
                                {this._CommaFormatted(payPoint)}포인트
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <a
                        style={{ cursor: 'pointer' }}
                        onClick={this._onUsePoint}
                      >
                        결제하기
                      </a>
                      <div
                        style={{ color: '#fff', fontSize: 11, paddingTop: 10 }}
                      >
                        - VOD 스트리밍/다운로드는 최초 결제일로부터 48시간 이내
                        PC or APP 재관람 및 다운로드가 가능합니다.(다운로드의
                        경우 최대 3회까지 가능)
                        <br />- 최초 결제일로부터 48시간이 초과될 경우 재결제를
                        진행하셔야 VOD 스트리밍/다운로드 이용 가능합니다.
                      </div>
                    </div>
                  </div>
                </Fragment>
              ) : (
                /*
                        <div>
                            <p>
                                {chksale === 'all' ? (
                                    <p>{ pointData[0].title }{payPoint}p {exception}전체 화수 일괄결제</p>
                                ) : (
                                    <p>{ pointData[0].title } {pointData[0].part}화   {payPoint}p {exception}</p>
                                )}
                                
                            </p>
                            <p>
                                보유포인트: {userPoint} - 차감포인트 {payPoint}P = 잔여포인트: {userPoint-payPoint}P
                            </p>
                            <p>
                                <button onClick={this._onUsePoint}>결제하기</button>
                            </p>
                            <p>
                            {contentSerial}, {contentPartSerial}, {subPartSerial2}, {subPartSerial3}, payGubun: {payGubun}, chksale: {chksale}
                            </p>
                        </div>
                        */
                <img
                  src={imgUrl + '/img/vod/vod_loading.png'}
                  style={{ backgroundColor: 'black' }}
                />
                /*<p>({intReturn}보유하신 포인트가 부족하거나1 )</p>*/
              )}
            </Fragment>
          ) : (
            /*<p>{intReturn}결제내역이 존재하지 않습니다.</p>*/
            <img
              src={imgUrl + '/img/vod/vod_loading.png'}
              style={{ backgroundColor: 'black' }}
            />
          )
        ) : (
          /*<p>{intReturn}지원하지 않는 섭비스입니다. 관리자에게 문의해 주세요</p>*/
          <img
            src={imgUrl + '/img/vod/vod_loading.png'}
            style={{ backgroundColor: 'black' }}
          />
        )}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(UsePoint));
